export default {

    coffeeData: {
        windBreaker: "Wind Breaker Tree",
        horticultureInfo: "Horticulture Tree",
        shadeTree: "Shade Tree",
        coffeeVariety: "Coffee Variety",
        coffeeSpecies: "Coffee Species",
        coffeeCherryQuality: "Coffee Cherry Quality",
        processingBatchQuality: "Processing Batch Quality",
        processType: "Process Type",
        updateWindBreaker: "Update windBreaker Tree Type",
        addWindBreaker: "Add New windBreaker Tree Type",
        updateHorticultureInfo: "Update horticultureInfo Tree Type",
        addHorticultureInfo: "Add New horticultureInfo Tree Type",
        updateShadeTree: "Update shadeTree Tree Type",
        addShadeTree: "Add New shadeTree Tree Type",
        updateCoffeeVariety: "Update coffeeVariety Tree Type",
        addCoffeeVariety: "Add New coffeeVariety Tree Type",
        deleteVarietyTitle: "Delete Variety",
        deleteVarietyMessage: "Are you sure you want to delete Variety?",
        updateCoffeeSpecie: "Update Coffee Specie",
        deleteSpecieTitle: "Delete Specie",
        deleteSpecieMessage: "Are you sure you want to delete Specie?",
        addCoffeeSpecie: "Add New Coffee variety",
        variety: "Variety",
        selectVariety: "Select Specie",
        deleteCoffeeRecord: "Are you sure you want to delete record?",
        deleteCoffeeData: "Delete Coffee Data",
        topicRequired: "Select Topic is required",
        coffeeAddSuccess: "Coffee Specie added successfully.",
        treeTypeSuccess: "Tree type added successfully.",
        treeTypeUpdateSuccess: "Tree type updated successfully.",
        coffeeVarietySuccess: "Coffee variety added successfully.",
        coffeeSpecieSuccess: "Coffee specie updated successfully.",
        nameRequired: "Name is required",
        notFound: "No Admin Coffee data Found",
      },
      cacaoData: {
        cacao: "Cacao",
        cacaoVariety: "Cacao Variety",
        cacaoSpecies: "Cacao Species",
        cacaoWeight: "Cacao Weight",
        cacaoOverview: "Cacao Overview",
        "buysellOverview": "Buy/Sell Overview",
        cacaoType: "Cacao Type",
        deleteCacaoData: "Delete Cacao Data",
        productWeight: "Product Weight",
        productType: "Type of Product",
        productPricePerKg: "Price per KG",
        registerFermentation: "Register Fermentation",
        batchVisualIdentification: "Batch Visual Indentification",
        initialWeight: "Initial Weight",
        finalWeight: "Final Weight",
        performance: "Performance",
        fermentationPercentage: "Fermentation Percentage",
        fermetationMethod: "Fermentation Method",
        boxes: "Boxes",
        piles: "Piles",
        bags: "Bags",
        selectZone: "Select Zone",
        selectPlantation: "Select Plantation",
        deliveryMethod: "Delivery Method",
        totalPrice: "Total Price",
      },

  

  memberDataSection: {
    import: "Import",
    buyingStation: "Buying Station",
    factory: "Factory",
    factories: "Factories",
    factoryInfo: "Factory Info",
    continue: "Continue",
    farmerId: "Farmer ID",
    farmerName: "Farmer Name",
    farmerAddress: "Farmer Address",
    quality: "Quality",
    quantity: "Quantity",
    importAll: "Import All",
    importSelected: "Import Selected",
    fileLoaded: "File loaded successfully",
    incorrectHeaders: "Incorrect headers",
    processingBatch: "Processing Batch",
    purchaseOrder: "Purchase Order",
    startDate: "Start Date",
    endDate: "End Date",
    purchasingOrder: "Purchasing Order",
    totalCoffeeCherry: "Total Coffee Cherry",
    airHumidity: "Air Humidity",
    density: "Density",
    temperature: "Temperature",
    beanMoistureContent: "Bean Moisture Content",
    processType: "Process Type",
    batchRating: "Select Rating Of The Batch",
    purchaseDate: "Purchase Date",
    selectFarmer: "Select Farmer",
    selectFarmers: "Select Farmers",
    selectFarm: "Select Farm",
    selectCrop: "Select Crop",
    selectPlantation: "Select Plantation",
    coffeeVariety: "Coffee Variety",
    coffeeSpecies: "Coffee Species",
    coffeeCherryQuantity: "Coffee Cherry Quantity",
    coffeeCherryQuality: "Coffee Cherry Quality",
    coffeeType: "Type of Coffee",
    pricePerKg: "Price Per Kg",
    processingDone: "Processing Done",
    processedCoffeeOut: "Processed Coffee Out",
    farmer: "Farmer",
    farm: "Farm",
    plantation: "Plantation",

    // Lately added
    farmers: "Farmers",
    farmLimitUsed: "Farm Limit Used",
    phoneNumber: "Phone Number",
    farmSize: "Farm Size",
    farmLocation: "Farm/Location",
    date: "Date",
    status: "Status",
    noFarmers: "No Farmers Found",
    approveReject: "Approve/Reject",
    farms: "Farms",
    crops: "Crops",
    equipment: "Equipment",
    noFarms: "No Farms Found",
    views: "View",
    selectStatus: "Select Status",
    approved: "Approved",
    rejected: "Rejected",
    reject: "Reject",
    approve: "Approve",
    cancel: "Cancel",
    add: "Add",
    describeYourReason: "Describe your reason here",
    userInformation: "User Information",
    userFarmRequest: "User Farm Request",
    userFarmInformation: "User Farm(s) Information",
    activity: "Activity",
    activityType: "Activity Type",
    farmZone: "Farm Zone",
    farmerView: "Farmer View",
    cropType: "Crop Type",
    cropVarity: "Crop Varity",
    area: "Area",
    cost: "Cost",
    geofence: "Geofence",
    map_views: "Map View",
    viewAllFarms: "View All Farms",
    farmersDetails: "Farmer Details",
    download: "Download",
    pOrder: {
      addNew: "Add New",
      viewAll: "View All",
      selectDate: "Select date",
      makeSelection: "Make a selection",
      coffeeType: "Type coffee quantity",
      enterPrice: "Enter Price",
      reqPurchaseDate: "Purchase date is required",
      reqFarmer: "Farmer is required",
      reqCoffeeQnty: "Coffee Cherry Quantity is required",
      reqPrice: "Price Per Kg is required",
      grandTotal: "GRAND TOTAL",
      selectDateRange: "Select Date Range",
      import: "Import",
      purchaseId: "Purchase Id",
      purchaseDate: "Purchase Date",
      farmerName: "Farmer Name",
      quality: "Quality",
      quantity: "Quantity",
      pricePerKg: "Price Per Kg",
      selectBuyingStation: "Select buying station",
      searchUser: "Search Users",
      purchaseListView: "Purchase List View",
      viewBy: "View by",
      typeDensity: "Type Density",
      typeTemperature: "Type temperature",
      typeWaterContent: "Type water content",
    },
    farmActivity: "Farm Activity",
    showOnMap: "Show On Map",
    farmInformation: "Farm Information",
    dateOfEntry: "Date Of Entry",
    farmID: "Farm ID",
    ownershipType: "Ownership Type",
    locationAddress: "Location Addresss",
    goalType: "Goal Type",
    totalSize: "Total Size",
    zones: "Zones",
    farmActivities: "Farm Activites",
    farmDetails: "Farm Details",
    totalFarmsRegistered: "Total Farms Registered",
    totalFarmArea: "Total Farm Area",
    totalZone: "Total Zone",
    zone: "Zone",

    totalCost: "Total Cost",
    selectFarmZone: "Select Zone/Farm",
    productionType: "Production Type",
    certifications: "Certifications",
    geofences: "Geofences",
    farmsChart: "Farms Chart",
    
    // Buying Station specific translations
    buyingStations: "Buying Stations",
    registerBuyingStation: "Register Buying Station",
    registerFactory: "Register Factory",
    loadingFactory: "Loading Factory...",
    loadingBuyingStation: "Loading Buying Station...",
    searchBuyingStation: "Search Buying Station",
    searchFactory: "Search Factory",
    nameAndId: "Name / ID",
    email: "Email",
    mobileNumber: "Mobile Number",
    role: "Role",
    actions: "Actions",
    view: "View",
    edit: "Edit",
    activate: "Activate",
    deactivate: "Deactivate",
    operator: "Operator",
    supplier: "Supplier",
    active: "Active",
    deactivated: "Deactivated",
    activatedSuccessfully: "Buying station activated successfully",
    deactivatedSuccessfully: "Buying station deactivated successfully",
  
    factoryActivatedSuccessfully: "Factory activated successfully",
    factoryDeactivatedSuccessfully: "Factory deactivated successfully",
    factoryRegisteredSuccessfully: "Factory registered successfully",
    
    // Buying Station Details specific translations
    userDetails: "User Details",
    name: "Name",
    provinceState: "Province/State",
    villageCityTown: "Village/City/Town",
    country: "Country",
    associatedFarms: "Associated Farms",
    back: "Back",
    addPurchaseOrder: "Add Purchase Order",
    search: "Search",
    orderId: "Order ID",
    farmFarmer: "Farm / Farmer",
    coffeeSpeciesVariety: "Coffee Species / Variety",
    quantityPrice: "Quantity / Price",
    delete: "Delete",
    
    // Processing Batch specific translations
    addProcessingBatch: "Add Processing Batch",
    batchId: "Batch ID",
    lots: "Lots",
    greenCoffeeOut: "Green Coffee Out",
    startEndDate: "Start Date/End Date",
    
    // Associated Farms specific translations
    addFarm: "Add Farm",
    farmNameAndId: "Farm Name & ID",
    addressOfProduction: "Address of Production",
    areaHa: "Area (ha)",
    type: "Type",
    eudrDeforestationStatus: "EUDR Deforestation Status",
    eudrDeforestationStatusTT: "EUDR Deforestation Risk Assessment Status",
    zeroNegligibleProbability: "Zero/Negligible Probability",
    assessments: "Assessments",
    riskAssessment: "Risk Assessment",
    compliant: "Compliant",
    nonCompliant: "Non-Compliant",
    pending: "Pending",
    dateOfSubmission: "Date of Submission",
    dateOfExpiry: "Date of Expiry",
    
    confirmDialog: {
      delete: {
        title: "Delete Buying Station",
        message: "Are you sure you want to delete this buying station?",
        confirmBtn: "Delete",
      }
    },
    
    registerNewFactory: "Register New Factory",
    selectHowYouWantToProceed: "Select how you want to proceed",
    single: "Single",
    multiple: "Multiple",
    user: "User",
    createNewFactory: "Create a New Factory",
    factoryName: "Factory Name",
    factoryNumber: "Factory Number",
    firstName: "First Name",
    lastName: "Last Name",
    primaryEmailAddress: "Primary Email Address",
    submit: "Submit",
  },
}